module.exports = __webpack_public_path__ + "fonts/Graphik-Medium.f58d53e.otf";